import { Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from '@material-ui/core';
import { Checkbox } from 'material-ui';
import * as React from 'react';
import './../ViewStyles/TableView.css';
import View from './View';

class TableView<P, S> extends View<P & Interfaces.ITableViewProps, S & Interfaces.ITableViewState> {

    constructor(props: any) {
        super(props);
        const defaultState: any = {
            selectedRows: [],
            page: 0
        }
        this.state = defaultState
    }

    public onDelete() {
        this.setState({ isDeleteConfirmationDialogOpened: true })
    }

    public onSelectRow(state: string | number) {
        const { selectedRows } = this.state;
        const { model } = this.props;
        let sR: any[] = []
        if (state === 'all') {
            sR = (model as any[]).map((x: any) => ({ index: (model as any[]).indexOf(x), selected: true }))
        } else if (state === 'none') {
            sR = (model as any[]).map(x => ({ index: (model as any[]).indexOf(x), selected: false }))
        } else {
            let selectedRow: object = (selectedRows.filter(r => r['index'] === state))[0]
            if (selectedRow) {
                selectedRows.forEach(r => r['selected'] = r['index'] === selectedRow['index'] ? !r['selected'] : r['selected'])
            } else {
                selectedRow = { index: state, selected: true }
                selectedRows.push(selectedRow)
            }
        }
        this.setState({ selectedRows: sR.length ? sR : selectedRows })
    }

    public objectsForDelete() {
        const { selectedRows } = this.state;
        const { model } = this.props;
        const objectForDelete: any[] = [];
        this.setState({ selectedRows: [] });
        const sRs = selectedRows.filter(sR => sR['selected'] === true);
        sRs.forEach(sR => {
            objectForDelete.push(model[sR['index']]);
        })
        return objectForDelete;
    }

    public tableViewHeader(): any[] { return [] }

    public render_topBar(): JSX.Element { return <div>Table top bar!</div> }

    public rowAtIndex(object: any, index: number) { return <div>Row at index!</div> }

    public labelRowsPerPage(): string { return '' }


    public withCheck() { return true; }

    public render(): JSX.Element {
        const { accessAvailable, model, dataCount, rowsPerPage, onChangePage, onChangeRowsPerPage } = this.props;
        const { selectedRows, page } = this.state;
        return (
            <Paper style={{ overflowX: 'hidden' }} className="dashboard-paper">
                {accessAvailable === undefined || accessAvailable === true?this.render_topBar():null}
                {(accessAvailable === undefined || accessAvailable === true)? 
                    <div style={{ width: '100%', overflowX: 'scroll', marginTop: 30 }} className="table-container">
                        <Table style={{ width: 1170 }}>
                            <TableHead>
                                <TableRow>
                                    {this.withCheck() ?
                                        <TableCell className="checkbox-cell" style={{ width: 30 }}>
                                            <Checkbox
                                                checked={selectedRows.length !== 0 && selectedRows.filter(r => r['selected'] === true).length === (model as any[]).length ? true : false}
                                                onCheck={() => this.onSelectRow(selectedRows.filter(r => r['selected'] === true).length === (model as any[]).length ? 'none' : 'all')}
                                            />
                                        </TableCell>
                                        : null}
                                    {this.tableViewHeader().map((c, i) => {
                                        return <TableCell style={{ minWidth: 50 }} key={i.toString()}> {c.label} </TableCell>
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(model as any[]).map((p, i) => {
                                    return this.rowAtIndex(p, i);
                                })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={dataCount}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={(e: any, p: number) => { this.setState({ page: p }); onChangePage(p) }}
                                        onChangeRowsPerPage={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => onChangeRowsPerPage(Number(e.target['value']))}
                                        labelDisplayedRows={(({ from, to, count }) => `${from}-${to} из ${count}`)}
                                        labelRowsPerPage={this.labelRowsPerPage()}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                    :
                    'В доступе отказано'
                }
                {this.deleteConfirmationDialog()}
                {this.loadingView()}
            </Paper>
        );
    }
}

export default TableView;



// WEBPACK FOOTER //
// ./src/app/abstract/Views/TableView.tsx